import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate, formateDateWithMonth, getFormatedTime, handleServerValidations, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import toHtml from "html-react-parser";

// import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import { subscribeForPremium, subscriptionHistoryList, unsubscribeFromPremium, userDetails } from "../../services/user.service";
import Swal from "sweetalert2";
import { SUBSCRIPTION_NAMES, SUBSCRIPTION_PRODUCT_IDS, SWAL_SETTINGS } from "../../../../utils/Constants";
import { SubscriptionHistoryList } from "../../services/subscriptionPlan.services";
import CustomRangepicker from "../../common/rangepicker";
import CustomPagination from "../../common/custompagination";
import { useDispatch } from "react-redux";
import { addUserData } from "../../../../redux/slices/userDetailsSlice";
    
const ViewUserDetails = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();
    const dispatch = useDispatch();
    // const [query] = useSearchParams();

    const [showdefault, setShowDefault] = useState({});
    const [statsupdate, setStatusUpdate] = useState("false");
    const [activeTab, setActiveTab] = useState("details");
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const [loader, setLoader] = useState(true);
    const [resetdate, setResetDate] = useState(false);
    

    // const breadcrumbs = [
    //     { title: t("link_dashboard"), url: "/admin/dashboard" },
    //     {
    //         title: t("User"),
    //         url: "/admin/user-management/user/list/1",
    //     },
    //     { title: t("View"), url: "" },
    // ];

    useEffect(() => {
        userDetails(params.id)
            .then((response) => {
                // console.log("View response-", response);
                let d = new Date(response?.data?.date_of_birth) || new Date();
                const safeDate = new Date(
                    d.getUTCFullYear(),
                    d.getUTCMonth(),
                    d.getUTCDate()
                );
                response.data.date_of_birth = safeDate;

                setShowDefault(response && response.data ? response.data : []);
                dispatch(addUserData(response?.data))
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id, statsupdate]);


    useEffect(() => {
        if(activeTab != 'subscriptionHistory')return;

        const getData = setTimeout(() => {
          if (search) {
            setLoader(true);
            const formData = new FormData();
            formData.append("page", params.pgno);
            formData.append("per_page", itemperpage);
            formData.append("sort", JSON.stringify(sorting));
            formData.append("search", JSON.stringify(search));
            formData.append("global_search", globalsearch);
            SubscriptionHistoryList(formData)
              .then((data) => {
                setDataLength(data.data.total_records);
                setSubscriptionList(data && data.data && data.data.list ? data.data.list : []);
                setPage(data && data.data && data.data.page ? data.data.page : 1);
                setLoader(false);
              })
              .catch((error) => {
                 setLoader(false);
                console.log("error ====> ", error);
              });
          }
        }, 300);
        return () => clearTimeout(getData)
      }, [
        activeTab,
        location,
        statsupdate,
        sorting,
        search,
        globalsearch,
        itemperpage,
        params.pgno,
    ]);

    const SubscribePremiumPlan = (o_id, plan_type) => {
        Swal.fire({
            customClass: "swal-wide",
            title: t(`Are you sure you want to provide this user ${SUBSCRIPTION_NAMES[plan_type]} subscription ?`),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                subscribeForPremium({ o_id: o_id, plan_type: plan_type })
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };
    const UnsubscribePremiumPlan = (o_id) => {
        Swal.fire({
            customClass: "swal-wide",
            title: t(`Are you sure you want to unsubscribe this user from the premium plan?`),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                unsubscribeFromPremium({ o_id: o_id })
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
        sort.order = -1;
        } else {
        sort.order = 1;
        }
        setSorting(sort);
    };
  // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
        sr[key] = value;
        } else {
        delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };

    return (
        <>
            {/* <Breadcrums data={breadcrumbs} /> */}
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">

                        <div className="card-body">
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table id="simple-table" className="table table-bordered table-hover">
                                            <tbody>
                                                {/* Profile Info Table (excluding subscription) */}
                                                <tr>
                                                    <th>Profile Image</th>
                                                    <td>
                                                        <img src={showdefault?.profile_image || "N/A"} alt="profile" style={{ height: "100px" }} />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Name")}</th>
                                                    <td className="text-capitalize">{showdefault?.name || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_email")}</th>
                                                    <td>{showdefault?.email || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_phone_number")}</th>
                                                    <td>{showdefault?.phone_number || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Gender")}</th>
                                                    <td>{showdefault?.gender || "N/A"}</td>
                                                </tr>

                                                <tr>
                                                    <th>Date of Birth</th>
                                                    <td className="text-capitalize">{showdefault?.date_of_birth ? formateDate(showdefault?.date_of_birth) : "N/A"}</td>
                                                </tr>

                                                <tr>
                                                    <th>Time of Birth</th>
                                                    <td className="text-capitalize">{showdefault?.time_of_birth || "N/A"}</td>
                                                </tr>

                                                <tr>
                                                    <th>Place of Birth</th>
                                                    <td className="text-capitalize">{showdefault?.place_of_birth || "N/A"}</td>
                                                </tr>

                                                <tr>
                                                    <th>{t("Country")}</th>
                                                    <td className="text-capitalize">{showdefault?.country || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("State")}</th>
                                                    <td className="text-capitalize">{showdefault?.state || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("City")}</th>
                                                    <td className="text-capitalize">{showdefault?.city || "N/A"}</td>
                                                </tr>

                                                
                                                <tr>
                                                    <th>{t("Referral Code")}</th>
                                                    <td>{showdefault?.referral_code || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Successfull Referred Count")}</th>
                                                    <td className="text-capitalize">{showdefault?.successfull_referred_count || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Wallet")}</th>
                                                    <tr>
                                                        <th>{t("Questions")}</th>
                                                        <td className="text-capitalize">{showdefault?.referral_earnings?.questions_count || 0}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{t("Reports")}</th>
                                                        <td className="text-capitalize">{showdefault?.referral_earnings?.reports_count || 0}</td>
                                                    </tr>
                                                </tr>
                                                {/* <tr>
                                                    <th>{t("Pin Code")}</th>
                                                    <td className="text-capitalize">{showdefault?.pin_code || "N/A"}</td>
                                                </tr> */}
                                                
                                                {/* <tr>
                                                    <th>{t("Date of Birth")}</th>
                                                    <td>{showdefault?.date_of_birth ? formateDate(showdefault.date_of_birth) : "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Time of Birth")}</th>
                                                    <td>{showdefault?.time_of_birth ? getFormatedTime(showdefault.time_of_birth) : "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("Place of birth")}</th>
                                                    <td>{showdefault?.place_of_birth || "N/A"}</td>
                                                </tr> */}
                                                <tr>
                                                    <th>{t("list_heading_status")}</th>
                                                    <td>
                                                    {showdefault && showdefault?.status == true ? toHtml(showStatus(1)) : toHtml(showStatus(0))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_created_date")}</th>
                                                    <td>{showdefault?.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                                                </tr>
                                                <tr>
                                                <th>{t("astro_chat_review")}</th>
                                                <td>
                                                    {showdefault?.astro_chat_experience === true && (
                                                    <i className="fa fa-thumbs-up text-success"></i>
                                                    )}

                                                    {showdefault?.astro_chat_experience === false && (
                                                    <i className="fa fa-thumbs-down text-danger"></i>
                                                    )}

                                                    {(showdefault?.astro_chat_experience === null ||
                                                    showdefault?.astro_chat_experience === undefined) && (
                                                    <span className="text-muted">N/A</span>
                                                    )}
                                                </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Loader />
                            )}
                        </div>

                        {/* Back Button */}
                        <div className="mt-2 back-button">
                            <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewUserDetails;
